export default "__VITE_ASSET__a3f3846a__"